import { useEffect, useState } from 'react';

import AuthService from '../../shared/services/AuthService';
import { AxiosError } from 'axios';
import Config from '../../shared/config';
import { PortfolioStatisticsModel } from '../models/PortfolioStatisticsModel';
import useSWRMutation from 'swr/mutation';

export interface EstimationArgType {
  modulekey: number;
  version: number;
}
const useModulesCompletionTime = () => {
  const [estimationTime, setEstimationTime] = useState<number>(null);
  const completionTimeUrl = `${Config.API}/api/portfolio/list/statistics/module`;

  const headers = {
    Authorization: `Bearer ${AuthService.getAccessToken()}`,
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  const fetcher = async (url: string, { arg }: { arg: EstimationArgType }) => {
    const portfolioUrl =
      arg.modulekey && arg.version
        ? `${url}/${arg.modulekey}/version/${arg.version}`
        : null;

    return fetch(portfolioUrl, {
      headers,
      method: 'GET'
    }).then(async (res) => await res.json());
  };

  const {
    trigger: loadEstimate,
    isMutating: loadingEstimation,
    data: estimationData,
    error
  } = useSWRMutation<
    PortfolioStatisticsModel,
    AxiosError<Error>,
    any,
    EstimationArgType
  >(completionTimeUrl, fetcher);

  useEffect(() => {
    if (estimationData) {
      setEstimationTime(estimationData.median_s);
    }
  }, [estimationData]);

  return {
    loadEstimate,
    loadingEstimation,
    loadPortfolioError: error,
    estimationTime
  };
};

export default useModulesCompletionTime;
